import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  actionExtraIcon: {
    cursor: "pointer",
    marginLeft: "3px",
  },
  editCommentButton: {
    backgroundColor: "#308CDB",
    alignItems: "center",
    width: 24,
    height: 24,
    border: "1px solid #20639D",
    borderRadius: 4,
  },
  commentInput: {
    maxWidth: "60px",
    marginRight: "8px",
  },
  iconButton: {
    marginRight: "5px",
  },
  button: {
    background: "#308CDB",
    color: "white",
    fontSize: "14px",
    padding: "5px 8px",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #20639D",
  },
  productLengthTitle: {
    color: "#465869",
    fontWeight: 600,
    marginRight: "8px",
  },
  latestScanDiv: {
    marginTop: "24px",
  },
  lineSeparator: {
    width: "inherit",
    marginTop: "16px",
    marginBottom: "16px",
    border: "1px solid #E0E2E7",
  },
  quantityDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  quantityInput: {
    maxWidth: "100px",
  },
}));

export default styles;
